<div>
  <button
    [type]="type"
    [class]="class"
    [disabled]="disabled !== undefined"
    [ngClass]="variant"
  >
    {{ label }}
  </button>
</div>
